import { readerRequest } from './readerActivity';
const BASE = process.env.REACT_APP_FOLLOW_API_BASE || 'https://j8s1yjjjuf.execute-api.us-west-2.amazonaws.com/default';
const normalize = value => {
  if (typeof value === 'string') return {id:value,name:value};
  return {id:value?.id || value?.authorId || value?.sub || value?.genreId || value?.slug || value?.name, name:value?.name || value?.displayName || value?.authorName || value?.label || value?.genre || value?.id};
};
export async function getReaderFollowGraph(options = {}) {
  const data = await readerRequest(`${BASE}/get-reader-follow-graph`,options);
  const raw = data.graph || data;
  const graph = { readerSub:data.readerSub };
  for (const [key, legacy] of [['genres','followedGenres'],['authors','followedAuthors'],['groups','followedGroups']]) {
    const values = raw[key] ?? raw[legacy] ?? (key === 'groups' ? [] : null);
    if (!Array.isArray(values)) throw new Error('Your circles could not be loaded. Please retry.');
    const items=values.map(normalize);
    if(items.some(item=>typeof item.id!=='string'||!item.id.trim()||typeof item.name!=='string'||!item.name.trim()))throw new Error('Your circles could not be loaded. Please retry.');
    graph[key]=[...new Map(items.map(item=>[item.id,item])).values()];
  }
  return graph;
}
async function updateFollow(action,type,target,options) {
  const item=normalize(target);
  if(typeof item.id!=='string'||!item.id.trim()||typeof item.name!=='string')throw new Error('Choose a valid circle.');
  const targetId=type==='genre'?item.id.trim().toLowerCase():item.id.trim();
  if(targetId.length>160||item.name.length>200)throw new Error('That circle name is too long.');
  if(type==='author'&&!/^[a-f0-9]{8}(-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i.test(targetId))throw new Error('Open the author’s website to join their Circle.');
  if(type==='group'&&!/^[a-z0-9]+(-[a-z0-9]+)*\.bookishcircle\.com$/.test(targetId))throw new Error('Enter the publishing group’s Bookish Circle website address.');
  const data=await readerRequest(`${BASE}/${action}`,{...options,method:'POST',body:{type,targetId,targetName:item.name.trim()||targetId}});
  if(data.status!==(action==='follow'?'followed':'unfollowed')||data.type!==type||data.targetId!==targetId)throw new Error('The change could not be confirmed. Refresh your circles before trying again.');
  return data;
}
export const followGenre=(target,options)=>updateFollow('follow','genre',target,options);
export const unfollowGenre=(target,options)=>updateFollow('unfollow','genre',target,options);
export const followAuthor=(target,options)=>updateFollow('follow','author',target,options);
export const unfollowAuthor=(target,options)=>updateFollow('unfollow','author',target,options);
export const followGroup=(target,options)=>updateFollow('follow','group',target,options);
export const unfollowGroup=(target,options)=>updateFollow('unfollow','group',target,options);
